module.exports = __webpack_public_path__ + "static/media/horseracing-icon.c404fcf1.svg";